import { captureException } from '@sentry/core';
import { consoleSandbox } from '@sentry/utils';
import { formatComponentName, generateComponentTrace } from './vendor/components.js';
var attachErrorHandler = function attachErrorHandler(app, options) {
  var _app$config = app.config,
    errorHandler = _app$config.errorHandler,
    warnHandler = _app$config.warnHandler,
    silent = _app$config.silent;
  app.config.errorHandler = function (error, vm, lifecycleHook) {
    var componentName = formatComponentName(vm, false);
    var trace = vm ? generateComponentTrace(vm) : '';
    var metadata = {
      componentName: componentName,
      lifecycleHook: lifecycleHook,
      trace: trace
    };
    if (options.attachProps && vm) {
      // Vue2 - $options.propsData
      // Vue3 - $props
      if (vm.$options && vm.$options.propsData) {
        metadata.propsData = vm.$options.propsData;
      } else if (vm.$props) {
        metadata.propsData = vm.$props;
      }
    }

    // Capture exception in the next event loop, to make sure that all breadcrumbs are recorded in time.
    setTimeout(function () {
      captureException(error, {
        captureContext: {
          contexts: {
            vue: metadata
          }
        },
        mechanism: {
          handled: false
        }
      });
    });
    if (typeof errorHandler === 'function') {
      errorHandler.call(app, error, vm, lifecycleHook);
    }
    if (options.logErrors) {
      var hasConsole = typeof console !== 'undefined';
      var message = "Error in ".concat(lifecycleHook, ": \"").concat(error && error.toString(), "\"");
      if (warnHandler) {
        warnHandler.call(null, message, vm, trace);
      } else if (hasConsole && !silent) {
        consoleSandbox(function () {
          // eslint-disable-next-line no-console
          console.error("[Vue warn]: ".concat(message).concat(trace));
        });
      }
    }
  };
};
export { attachErrorHandler };